import { getCatalogSearchSuggestions } from '@shared/shop-api/product/api'
import type { ContentfulCollection, Entry } from 'contentful'
import { getContentfulApiClient } from 'internal/api-client'

import { trackError } from '@fond-of/telemetry'

const { getEntriesByFieldValueMatch } = getContentfulApiClient()

const getContentSearchSuggestions = async (query: string) => {
  try {
    if (query.length > 1) {
      const suggestions: string[] = []
      const queryLower = query.toLowerCase()

      const { items } = (await getEntriesByFieldValueMatch(
        'searchTerms',
        query,
        {
          content_type: 'page',
          include: 0,
        }
      )) as unknown as ContentfulCollection<Entry<{ title?: string }>>

      items.forEach((item) => {
        const matchingTerms = item.fields?.title?.split(',')

        if (matchingTerms) {
          let suggestion = matchingTerms.find((item) =>
            item.toLowerCase().includes(queryLower)
          )

          if (!suggestion) {
            ;[suggestion] = matchingTerms
          }

          if (suggestion) {
            suggestions.push(suggestion)
          }
        }
      })

      return {
        content: suggestions,
      }
    }

    return {}
  } catch (error) {
    trackError(error)
    return {}
  }
}

// TODO: move to shop api 17-09-2024

export const getSearchSuggestions = async (query: string) => {
  try {
    const [catalogSearchSuggestions, contentSearchSuggestions] =
      await Promise.all([
        getCatalogSearchSuggestions(query),
        getContentSearchSuggestions(query),
      ])

    return {
      ...catalogSearchSuggestions,
      ...contentSearchSuggestions,
    }
  } catch (error) {
    trackError(error)

    return {}
  }
}
